import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative drop-shadow-xl" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "aspect-video" }, null, -1)
const _hoisted_3 = { class: "absolute z-10 py-1 px-2 top-3 left-3 bg-black/60 text-white rounded shadow" }
const _hoisted_4 = { class: "" }
const _hoisted_5 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.category.name), 1)
    ]),
    _createElementVNode("img", {
      class: "absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 object-cover w-full h-full rounded-2xl overflow-hidden",
      src: _ctx.category.image,
      alt: _ctx.category.name
    }, null, 8, _hoisted_5)
  ]))
}